import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import { technicianSelectProps } from "../../utils/technicianFilter.js";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  DateRangeFields,
  Select,
  Modal,
  GET,
  GET_FILE,
  saveAs,
  profile,
  t,
} from "../../components/CustomComponent.js";
import {
  toDateOnly,
  currentWeekRange,
  rangeDays,
  fmtDate,
  fmtMinutes,
  pruneParams,
  hasPermission,
} from "../../utils/timeTracking.js";
import "../../assets/css/time-tracking.css";

import { formatNumber } from "../../utils/formatting";
const PAGE_SIZE = 50;
// ช่วงวันที่สูงสุดที่ backend รับ (รวมวันแรกและวันสุดท้าย)
const MAX_RANGE_DAYS = 31;
const F3_OPTIONS = [600, 720, 840];
const FLAGS = ["F1", "F2", "F3"];
// แหล่งที่เลือกได้ (รับประกัน/PM โครงการนับรวมในงานติดตั้ง)
const SOURCES = ["WO", "INS", "POOL", "ACT"];
const SOURCE_COLUMNS = SOURCES;
const SOURCE_COLORS = { WO: "#3557DB", INS: "#7B3FD0", POOL: "#0E8A96", ACT: "#E39B22" };

const pad = (n) => String(n).padStart(2, "0");
// นาทีนับจาก 00:00 ของวันที่เริ่ม -> "HH:mm" (เกิน 24:00 = ข้ามคืน ต่อท้าย (+1))
const hm = (min) => {
  if (min === null || min === undefined) return "";
  return min >= 1440 ? `${pad(Math.floor((min - 1440) / 60))}:${pad((min - 1440) % 60)} (+1)` : `${pad(Math.floor(min / 60))}:${pad(min % 60)}`;
};

// หน้า "รายงานลงเวลาทำงาน" (Timesheet Report) - ดูอย่างเดียว + Export xlsx
// field ตรงกับ SNAPA-Backend modules/admin/timesheet-report
//   GET admin/timesheet-reports          -> data={rows,kpi} + pagination (1 แถว = 1 คน/วัน)
//   GET admin/timesheet-reports/details  -> data={rows,kpi} + pagination (1 แถว = 1 รายการงาน)
//   GET admin/timesheet-reports/timeline -> data={...สรุปคน/วัน, items}
//   GET admin/timesheet-reports/export   -> xlsx 3 ชีต (GET_FILE เพราะเป็น binary)
export default class AdminTimesheetReport extends Component {
  constructor(props) {
    super(props);
    const week = currentWeekRange();
    this.canExport = hasPermission(profile, "timesheet_report.export");
    this.state = {
      filter_from: week.from,
      filter_to: week.to,
      filter_department_uid: "",
      filter_technician_uid: "",
      filter_flag: "",
      filter_f3: 720,
      filter_sources: [...SOURCES],
      preset: "week",
      view: "pd",

      rows: [],
      kpi: null,
      count: 0,
      page: 1,
      loaded: false,
      data_departments: [],
      data_technicians: [],

      detail: null, // timeline ของคน/วันที่เปิดอยู่
    };
  }

  async componentDidMount() {
    loading(false);
    // ตัวกรองแผนก (แทน BU เดิม) - เฉพาะแผนกที่ใช้งานอยู่ของบริษัท เรียงตามรหัสแผนก
    const dept = await GET("admin/departments", { page_size: 1000, page: 0, data_search: "", is_active: "true", scope_department: "true" });
    if (dept?.status && Array.isArray(dept.data)) {
      const data_departments = [...dept.data].sort((a, b) => String(a.department_code || "").localeCompare(String(b.department_code || ""), "th", { numeric: true }) || String(a.name || "").localeCompare(String(b.name || ""), "th"));
      this.setState({ data_departments });
    }
    // รายชื่อช่างสำหรับ dropdown พนักงาน (backend กรองตามสิทธิ์แผนกของผู้ใช้แล้ว)
    const options = await GET("admin/timesheet-reports/filter-options");
    if (options?.status && options.data) this.setState({ data_technicians: options.data.technicians || [] });
    this.Get();
  }

  buildParams = () => {
    const { filter_from, filter_to, filter_department_uid, filter_technician_uid, filter_flag, filter_f3, filter_sources } = this.state;
    return pruneParams({
      from: filter_from,
      to: filter_to,
      department_uid: filter_department_uid,
      technician_uid: filter_technician_uid,
      flag: filter_flag,
      f3_minutes: filter_f3,
      sources: filter_sources.join(","),
    });
  };

  // true = ช่วงวันที่ไม่ถูกต้อง (แจ้งเตือนแล้ว)
  rangeError = () => {
    const { filter_from, filter_to } = this.state;
    let key = "";
    if (!filter_from || !filter_to) key = "att_range_required";
    else if (filter_from > filter_to) key = "att_range_order";
    else if (rangeDays(filter_from, filter_to) > MAX_RANGE_DAYS) key = "ts_range_too_long";
    if (!key) return false;
    alert("", "warning", t("warning"), t(key));
    return true;
  };

  Get = async (page = 1) => {
    if (this.rangeError()) return;
    const { view } = this.state;
    loading(true);
    const result = await GET(view === "pd" ? "admin/timesheet-reports" : "admin/timesheet-reports/details", {
      ...this.buildParams(),
      page,
      limit: PAGE_SIZE,
    });
    const rows = result?.status ? result.data?.rows || [] : [];
    this.setState({
      rows,
      kpi: result?.status ? result.data?.kpi || null : null,
      count: result?.pagination?.count ?? rows.length,
      page,
      loaded: true,
      detail: null,
    });
    loading(false);
  };

  SetFilter = (patch) => this.setState(patch, () => this.Get(1));

  // เปลี่ยนแผนก -> พนักงานกลับเป็น "ทั้งหมดในแผนก"
  ChangeDepartment = (departmentUid) => this.SetFilter({ filter_department_uid: departmentUid || "", filter_technician_uid: "" });

  ApplyPreset = (key) => {
    const today = new Date();
    let from = new Date(today);
    let to = new Date(today);
    if (key === "week" || key === "lweek") {
      from.setDate(today.getDate() - ((today.getDay() + 6) % 7) - (key === "lweek" ? 7 : 0));
      if (key === "lweek") {
        to = new Date(from);
        to.setDate(from.getDate() + 6);
      }
    }
    if (key === "month") from = new Date(today.getFullYear(), today.getMonth(), 1);
    this.SetFilter({ filter_from: toDateOnly(from), filter_to: toDateOnly(to), preset: key });
  };

  ToggleSource = (source) => {
    const { filter_sources } = this.state;
    const next = filter_sources.includes(source) ? filter_sources.filter((s) => s !== source) : [...filter_sources, source];
    if (!next.length) return; // ต้องเลือกอย่างน้อย 1 แหล่ง
    this.SetFilter({ filter_sources: SOURCES.filter((s) => next.includes(s)) });
  };

  ResetFilter = () => {
    const week = currentWeekRange();
    this.SetFilter({ filter_from: week.from, filter_to: week.to, preset: "week", filter_department_uid: "", filter_technician_uid: "", filter_flag: "", filter_sources: [...SOURCES] });
  };

  Export = async () => {
    if (this.rangeError()) return;
    loading(true);
    const result = await GET_FILE("admin/timesheet-reports/export", this.buildParams());
    if (result?.status && result.blob) {
      saveAs(result.blob, `Timesheet_${this.state.filter_from}_${this.state.filter_to}.xlsx`);
    } else {
      alert("", "warning", t("warning"), result?.message || t("ts_export_failed"));
    }
    loading(false);
  };

  OpenTimeline = async (row) => {
    loading(true);
    const result = await GET("admin/timesheet-reports/timeline", {
      date: row.date,
      person_key: row.person_key,
      sources: this.state.filter_sources.join(","),
      f3_minutes: this.state.filter_f3,
    });
    loading(false);
    if (result?.status && result.data) this.setState({ detail: result.data });
  };

  // ---------------------------------------------------------------- render
  srcLabel = (s) => t(`ts_src_${s}`);

  renderFlags = (flags) =>
    flags.length ? (
      flags.map((f) => (
        <span key={f} className="tt-badge tt-b-crit me-1" title={t(`ts_flag_${f}_title`)}>{f}</span>
      ))
    ) : (
      <span className="tt-badge tt-b-in">{t("ts_normal")}</span>
    );

  renderKpi() {
    const { kpi, filter_sources, filter_flag } = this.state;
    if (!kpi) return null;
    const cards = [
      [`${formatNumber(kpi.person_days)} ${t("ts_unit_person_days")}`, formatNumber(kpi.employees), "", false],
      [t("ts_kpi_total"), fmtMinutes(kpi.total_min), "", true],
      ...SOURCES.filter((s) => filter_sources.includes(s)).map((s) => [this.srcLabel(s), fmtMinutes(kpi.by_source[s]), SOURCE_COLORS[s], true]),
    ];
    return (
      <div className="tt-kpis">
        {cards.map(([label, value, color, mono]) => (
          <div className="tt-kpi static" key={label}>
            <small>{label}</small>
            <b className={mono ? "tt-mono" : ""} style={{ color: color || undefined }}>{value}</b>
          </div>
        ))}
        <div
          className={`tt-kpi ${filter_flag === "ANY" ? "sel" : ""}`}
          style={{ borderColor: "#F2B7B7" }}
          onClick={() => this.SetFilter({ filter_flag: filter_flag === "ANY" ? "" : "ANY" })}
          data-testid="ts-kpi-flag"
        >
          <small>{t("ts_kpi_flagged")}</small>
          <b style={{ color: "var(--tt-crit)" }}>{formatNumber(kpi.flagged_days)}</b>
        </div>
      </div>
    );
  }

  empty = (cols) => (
    <tr>
      <td colSpan={cols} className="text-center text-secondary py-5">
        {t("no_data")}
        <div><ClearFilterButton className="mt-2" onClick={this.ResetFilter} /></div>
      </td>
    </tr>
  );

  renderBar = (bySource) => {
    const sum = SOURCE_COLUMNS.reduce((s, k) => s + (bySource[k] || 0), 0) || 1;
    return (
      <div style={{ display: "flex", height: 8, width: 90, borderRadius: 4, overflow: "hidden", background: "#EEF0F5" }}>
        {SOURCE_COLUMNS.filter((k) => bySource[k]).map((k) => (
          <i key={k} style={{ width: `${(bySource[k] / sum) * 100}%`, background: SOURCE_COLORS[k] }} />
        ))}
      </div>
    );
  };

  renderSummary() {
    const { rows } = this.state;
    const tot = { total: 0, items: 0 };
    SOURCE_COLUMNS.forEach((k) => (tot[k] = 0));
    rows.forEach((r) => {
      tot.total += r.total_min;
      tot.items += r.item_count;
      SOURCE_COLUMNS.forEach((k) => (tot[k] += r.by_source[k] || 0));
    });
    const dash = (min) => (min ? fmtMinutes(min) : <span className="text-secondary">–</span>);
    return (
      <div className="tt-tblwrap">
        <table className="tt-tbl" style={{ minWidth: 1250 }}>
          <thead>
            <tr>
              <th>{t("date")}</th>
              <th>{t("code")}</th>
              <th>{t("name")} / {t("department")}</th>
              <th>{t("ts_bu")}</th>
              <th>{t("ts_col_first")}</th>
              <th>{t("ts_col_last")}</th>
              {SOURCE_COLUMNS.map((k) => <th key={k} className="num" style={{ color: SOURCE_COLORS[k] }}>{this.srcLabel(k)}</th>)}
              <th className="num">{t("ts_col_total")}</th>
              <th className="num">{t("ts_col_items")}</th>
              <th>{t("ts_col_ratio")}</th>
              <th>{t("ts_col_flags")}</th>
            </tr>
          </thead>
          <tbody>
            {!rows.length ? this.empty(6 + SOURCE_COLUMNS.length + 4) : rows.map((r) => (
              <tr key={`${r.person_key}|${r.date}`} className="click" style={r.flags.length ? { background: "#FFF9F9" } : undefined} onClick={() => this.OpenTimeline(r)}>
                <td>{fmtDate(r.date)}</td>
                <td className="tt-mono"><b>{r.code || "-"}</b></td>
                <td>{r.name}<div className="tt-mini">{r.department || "-"}</div></td>
                <td className="tt-mono">{(r.bu_codes || []).join(", ") || <span className="text-secondary">–</span>}</td>
                <td className="tt-mono">{hm(r.first_min)}</td>
                <td className="tt-mono">{r.last_min !== null ? hm(r.last_min) : <span className="text-secondary">–</span>}</td>
                {SOURCE_COLUMNS.map((k) => <td key={k} className="num tt-mono">{dash(r.by_source[k])}</td>)}
                <td className="num tt-mono"><b>{dash(r.total_min)}</b></td>
                <td className="num">{formatNumber(r.item_count)}</td>
                <td>{this.renderBar(r.by_source)}</td>
                <td>{this.renderFlags(r.flags)}</td>
              </tr>
            ))}
            {rows.length ? (
              <tr className="tot">
                <td colSpan="6">{t("total")}</td>
                {SOURCE_COLUMNS.map((k) => <td key={k} className="num tt-mono">{dash(tot[k])}</td>)}
                <td className="num tt-mono">{dash(tot.total)}</td>
                <td className="num">{tot.items}</td>
                <td colSpan="2" />
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    );
  }

  renderEvidence = (item) => {
    if (item.source === "POOL" && item.pool_card) {
      return <span className={`tt-badge ${item.pool_card === "signed" ? "tt-b-in" : "tt-b-warn"}`}>{t(item.pool_card === "signed" ? "ts_pool_signed" : "ts_pool_unsigned")}</span>;
    }
    if (item.distance_m !== null && item.distance_m !== undefined) return <span className="tt-mini">GPS ✔ {Math.round(item.distance_m)} {t("ts_meter")}</span>;
    return <span className="text-secondary">–</span>;
  };

  renderSourceBadge = (source) => (
    <span className="tt-badge" style={{ background: SOURCE_COLORS[source], color: "#fff" }}>{this.srcLabel(source)}</span>
  );

  renderCustomer = (item) => (
    <>
      {item.customer || <span className="text-secondary">–</span>}
      {item.free_project ? <span className="tt-badge tt-b-none ms-1">{t("ts_no_project")}</span> : null}
    </>
  );

  renderDetails() {
    const { rows } = this.state;
    return (
      <div className="tt-tblwrap">
        <table className="tt-tbl" style={{ minWidth: 1250 }}>
          <thead>
            <tr>
              <th>{t("date")}</th>
              <th>{t("code")}</th>
              <th>{t("name")}</th>
              <th>{t("ts_col_source")}</th>
              <th>{t("ts_bu")}</th>
              <th>{t("ts_col_ref")}</th>
              <th>{t("ts_col_customer")}</th>
              <th>{t("ts_col_desc")}</th>
              <th>{t("ts_col_start")}</th>
              <th>{t("ts_col_end")}</th>
              <th className="num">{t("att_hour")}</th>
              <th>{t("ts_col_evidence")}</th>
            </tr>
          </thead>
          <tbody>
            {!rows.length ? this.empty(12) : rows.map((r, i) => (
              <tr key={`${r.person_key}|${r.date}|${i}`} className="click" onClick={() => this.OpenTimeline(r)}>
                <td>{fmtDate(r.date)}</td>
                <td className="tt-mono"><b>{r.code || "-"}</b></td>
                <td>{r.name}</td>
                <td>{this.renderSourceBadge(r.source)}</td>
                <td className="tt-mono">{r.bu_code || <span className="text-secondary">–</span>}</td>
                <td className="tt-mono">{r.ref || <span className="text-secondary">–</span>}</td>
                <td>{this.renderCustomer(r)}</td>
                <td>{r.description || "-"}</td>
                <td className="tt-mono">{hm(r.start_min)}</td>
                <td className="tt-mono">{r.open ? <span className="tt-badge tt-b-crit">{t("ts_open")}</span> : hm(r.end_min)}</td>
                <td className="num tt-mono">{r.open ? <span className="text-secondary">–</span> : fmtMinutes(r.duration_min)}</td>
                <td>{this.renderEvidence(r)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderLane(source, items, lo, hi, gridLines) {
    const span = hi - lo;
    const pct = (m) => `${(((m - lo) / span) * 100).toFixed(2)}%`;
    return (
      <div key={source} style={{ display: "grid", gridTemplateColumns: "100px 1fr", gap: 8, alignItems: "center", marginBottom: 6 }}>
        <div className="tt-mini">{this.srcLabel(source)}</div>
        <div style={{ position: "relative", height: 26, background: "var(--tt-surface-2)", borderRadius: 4, overflow: "hidden" }}>
          {gridLines}
          {items.filter((i) => i.source === source).map((i, idx) => {
            const end = i.open ? Math.min(hi, i.start_min + 120) : i.end_min;
            return (
              <div
                key={idx}
                title={`${hm(i.start_min)}-${i.open ? t("ts_open") : hm(i.end_min)} ${i.ref || ""} ${i.description || ""}`}
                style={{
                  position: "absolute",
                  left: pct(i.start_min),
                  width: `${(((end - i.start_min) / span) * 100).toFixed(2)}%`,
                  top: 3,
                  bottom: 3,
                  background: i.open ? `repeating-linear-gradient(45deg, ${SOURCE_COLORS[source]}55, ${SOURCE_COLORS[source]}55 6px, #fff 6px, #fff 12px)` : SOURCE_COLORS[source],
                  border: i.open ? "1px solid var(--tt-crit)" : "none",
                  borderRadius: 4,
                  color: i.open ? "var(--tt-ink)" : "#fff",
                  fontSize: 10.5,
                  padding: "0 4px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {i.ref || i.description}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderDrawer() {
    const { detail } = this.state;
    if (!detail) return null;
    const items = detail.items || [];
    let lo = 360;
    let hi = 1320;
    items.forEach((i) => {
      lo = Math.min(lo, Math.floor(i.start_min / 120) * 120);
      if (i.end_min !== null) hi = Math.max(hi, Math.ceil(i.end_min / 120) * 120);
    });
    const span = hi - lo;
    const ticks = [];
    for (let m = lo; m <= hi; m += 120) ticks.push(m);
    const gridLines = ticks.map((m) => (
      <i key={m} style={{ position: "absolute", top: 0, bottom: 0, left: `${(((m - lo) / span) * 100).toFixed(2)}%`, width: 1, background: "var(--tt-line)" }} />
    ));
    const kv = [
      [fmtMinutes(detail.total_min), t("ts_drawer_total")],
      [hm(detail.first_min), t("ts_col_first")],
      [detail.last_min !== null ? hm(detail.last_min) : "–", t("ts_col_last")],
      [detail.item_count, t("ts_drawer_items")],
    ];

    return (
      <Modal show onHide={() => this.setState({ detail: null })} centered size="lg" scrollable contentClassName="border-0 rounded-4 shadow-lg" data-testid="ts-drawer">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <div>
            <h5 className="fw-bold mb-0 text-dark">{detail.name} <span className="tt-mono tt-mini fw-normal">{detail.code}</span></h5>
            <div className="tt-mini">{detail.department || "-"} · {fmtDate(detail.date)}</div>
          </div>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white tt-page">

          <div className="tt-kpis" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
            {kv.map(([value, label]) => (
              <div className="tt-kpi static" key={label}>
                <small>{label}</small>
                <b className="tt-mono" style={{ fontSize: 18 }}>{value}</b>
              </div>
            ))}
          </div>

          {detail.flags.length ? (
            <ul className="ps-3" style={{ background: "var(--tt-crit-soft)", borderRadius: 8, padding: "8px 8px 8px 24px" }}>
              {detail.flags.map((f) => (
                <li key={f}>
                  <b>{f} {t(`ts_flag_${f}_title`)}</b> - {t(`ts_flag_${f}_cond`)}
                  <div className="tt-mini">{t("ts_recommend")}: {t(`ts_flag_${f}_act`)}</div>
                </li>
              ))}
            </ul>
          ) : (
            <span className="tt-badge tt-b-in mb-2">{t("ts_no_anomaly")}</span>
          )}

          <div className="mt-2">
            {SOURCES.map((s) => this.renderLane(s, items, lo, hi, gridLines))}
            <div style={{ display: "grid", gridTemplateColumns: "100px 1fr", gap: 8 }}>
              <div />
              <div style={{ position: "relative", height: 16 }}>
                {ticks.map((m) => (
                  <span key={m} className="tt-mini tt-mono" style={{ position: "absolute", left: `${(((m - lo) / span) * 100).toFixed(2)}%`, transform: "translateX(-50%)" }}>
                    {pad(Math.floor(m / 60) % 24)}:00
                  </span>
                ))}
              </div>
            </div>
            <div className="tt-mini mt-1">{t("ts_tl_hint")}</div>
          </div>

          <div className="tt-tblwrap mt-3">
            <table className="tt-tbl">
              <thead>
                <tr>
                  <th>{t("ts_col_source")}</th>
                  <th>{t("ts_col_start")}</th>
                  <th>{t("ts_col_end")}</th>
                  <th className="num">{t("att_hour")}</th>
                  <th>{t("ts_col_ref")} / {t("ts_col_customer")}</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i, idx) => (
                  <tr key={idx}>
                    <td>{this.renderSourceBadge(i.source)}</td>
                    <td className="tt-mono">{hm(i.start_min)}</td>
                    <td className="tt-mono">{i.open ? <span className="tt-badge tt-b-crit">{t("ts_open")}</span> : hm(i.end_min)}</td>
                    <td className="num tt-mono">{i.open ? <span className="text-secondary">–</span> : fmtMinutes(i.duration_min)}</td>
                    <td style={{ whiteSpace: "normal" }}>
                      <span className="tt-mono">{i.ref}</span> {this.renderCustomer(i)}
                      <div className="tt-mini">{i.description}</div>
                      <div>{this.renderEvidence(i)}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="tt-mini mt-2 mb-0">{t("ts_readonly_note")}</p>
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end">
          <button type="button" className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ detail: null })}>{t("att_close")}</button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { view, filter_from, filter_to, filter_department_uid, filter_technician_uid, filter_flag, filter_f3, filter_sources, preset, data_departments, data_technicians, count, page, rows, loaded } = this.state;
    const presets = ["today", "week", "lweek", "month"];

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3 tt-page">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("ts_menu_timesheet_report")}</h3>
              <div className="text-secondary text-14">{t("ts_desc")}</div>
            </div>
            {this.canExport ? (
              <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.Export} disabled={!rows.length} data-testid="ts-export-btn">⬇ {t("att_export_btn")}</button>
            ) : null}
          </div>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
                <div className="d-flex gap-2">
                  <DateRangeFields
                    type="th"
                    className="form-control"
                    fieldStyle={{ flex: 1, minWidth: 0 }}
                    startPlaceholder={t("start_date")}
                    endPlaceholder={t("end_date")}
                    startValue={filter_from}
                    endValue={filter_to}
                    onChange={({ start, end }) => this.SetFilter({ filter_from: start, filter_to: end, preset: "" })}
                  />
                </div>
              </div>
              <div className="col-md-3" data-testid="ts-filter-department">
                <label className="form-label text-12 text-secondary mb-1">{t("department")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...data_departments.map((d) => ({ value: d.uid, label: [d.department_code, d.name].filter(Boolean).join(" ") }))]}
                  value={filter_department_uid}
                  onChange={(v) => this.ChangeDepartment(v)}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-5">
                <label className="form-label text-12 text-secondary mb-1">{t("att_filter_employee")}</label>
                <Select
                  className="form-control w-100"
                  {...technicianSelectProps(data_technicians, filter_department_uid, t)}
                  value={filter_technician_uid}
                  onChange={(v) => this.SetFilter({ filter_technician_uid: v || "" })}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("ts_flag")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, { value: "ANY", label: t("ts_flag_any") }, ...FLAGS.map((f) => ({ value: f, label: `${f} ${t(`ts_flag_${f}_title`)}` }))]}
                  value={filter_flag}
                  onChange={(v) => this.SetFilter({ filter_flag: v || "" })}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("ts_f3_label")}</label>
                <Select
                  className="form-control w-100"
                  options={F3_OPTIONS.map((m) => ({ value: String(m), label: t("ts_f3_option").replace("{h}", m / 60) }))}
                  value={String(filter_f3)}
                  onChange={(v) => this.SetFilter({ filter_f3: Number(v) })}
                  placeholder={t("ts_f3_option").replace("{h}", F3_OPTIONS[0] / 60)}
                />
              </div>
              <div className="col-md-6 d-flex justify-content-end">
                <ClearFilterButton onClick={this.ResetFilter} />
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
            <div className="tt-seg">
              {presets.map((p) => (
                <button key={p} type="button" className={preset === p ? "on" : ""} onClick={() => this.ApplyPreset(p)}>{t(`ts_preset_${p}`)}</button>
              ))}
            </div>
            <span className="tt-mini">{t("ts_max_range")}</span>
            <span className="tt-mini ms-3">{t("ts_sources")}:</span>
            {SOURCES.map((s) => (
              <label key={s} className="d-inline-flex align-items-center gap-1 tt-mini mb-0" style={{ cursor: "pointer" }}>
                <input type="checkbox" checked={filter_sources.includes(s)} onChange={() => this.ToggleSource(s)} />
                <i style={{ width: 10, height: 10, borderRadius: 2, background: SOURCE_COLORS[s], display: "inline-block" }} />
                {this.srcLabel(s)}
              </label>
            ))}
          </div>

          {this.renderKpi()}

          <div className="tt-viewbar">
            <div className="tt-seg">
              {["pd", "det"].map((v) => (
                <button key={v} type="button" className={view === v ? "on" : ""} onClick={() => view !== v && this.SetFilter({ view: v, rows: [] })}>{t(`ts_view_${v}`)}</button>
              ))}
            </div>
            <span className="tt-mini">{formatNumber(count)} {t(view === "pd" ? "ts_unit_person_days" : "ts_unit_items")} · {t("ts_click_row_hint")}</span>
          </div>

          {loaded ? (view === "pd" ? this.renderSummary() : this.renderDetails()) : null}

          <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap tt-mini">
            <div>
              {t("showing")} {count ? formatNumber((page - 1) * PAGE_SIZE + 1) : 0}-{formatNumber((page - 1) * PAGE_SIZE + rows.length)} {t("of")} {formatNumber(count)}
            </div>
            <Pagination className="mb-0" count={Math.ceil(count / PAGE_SIZE) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, next) => this.Get(next)} />
          </div>

          {this.renderDrawer()}
        </div>
      </div>
    );
  }
}
